document.addEventListener('addToCartCustom', function(event) {
    let properties = {};
    const { id, qty } = event.detail;
    if (event.detail?.properties) {
        properties = event.detail.properties;
    }    
    addToCartAndRefresh(id, qty, properties);

});

function updateCartCounter() {
    const cartDrawerCounter = document.querySelector(
        ".cart-drawer__title-counter"
    );

    fetch("/cart.json", {
        method: "GET",
        headers: {
            Accept: "application/json"
        }
    })
    .then(response => response.json())
    .then(data => (cartDrawerCounter.innerHTML = data.item_count))
    .catch(error => console.error('Error updating cart counter:', error));
}

function addToCartAndRefresh(vid, quantity = 1, properties = {}) {
    const formData = {
        items: [{
        id: vid,
        quantity: quantity,
        properties: properties
        }],
        sections: ['cart-drawer', 'cart-counter'],
    };

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(json => {
        let cartDrawer = document.querySelector("cart-drawer");
        cartDrawer.renderContents(json, true, false);

        document.dispatchEvent(new CustomEvent("customAddToCartComplete", { detail: json }));
        updateCartCounter();
    })
    .catch(error => console.error('Error adding to cart:', error));
}

window.refreshCart = function refreshCart() {
    fetch('/?sections=cart-drawer,cart-counter', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
    .then(response => response.json())
    .then(json => {
        console.log(json);
        let cartDrawer = document.querySelector("cart-drawer");
        cartDrawer.renderContents({ sections: json }, true, false);

        updateCartCounter();
    })
    .catch(error => console.error('Error refreshing cart:', error));
}

// document.addEventListener("click", function (e) {
//     if (e.target.matches("[data-rt-add-to-cart]")) {
//         e.preventDefault();
//         const button = e.target;
//         const variantId = button.dataset.rtVariantId;
//         const dataVariantId = button.getAttribute("data-rt-variant-id");

//         document.dispatchEvent(
//             new CustomEvent("addToCartCustom", {
//                 detail: { id: dataVariantId, qty: 1, properties: { _gift_product: "yes" } },
//             })
//         );
//     }
// });

document.addEventListener("DOMContentLoaded", function() {
  document.addEventListener("click", function (e) {
    // Handle gift product buttons (check if clicked element or its parent has the attribute)
    const giftButton = e.target.closest("[data-rt-add-to-cart]");
    if (giftButton) {
      e.preventDefault();
      const dataVariantId = giftButton.getAttribute("data-rt-variant-id");

      document.dispatchEvent(
        new CustomEvent("addToCartCustom", {
          detail: { id: dataVariantId, qty: 1, properties: { _gift_product: "yes" } },
        })
      );
      return; // Prevent handling both events if element has both attributes
    }

    // Handle default add to cart buttons (check if clicked element or its parent has the attribute)
    const defaultButton = e.target.closest("[data-rt-default-add-to-cart]");
    if (defaultButton) {
      e.preventDefault();
      const dataVariantId = defaultButton.getAttribute("data-rt-variant-id");

      document.dispatchEvent(
        new CustomEvent("addToCartCustom", {
          detail: { id: dataVariantId, qty: 1 },
        })
      );
    }
  });
});